<template>
  <div class="jinjuenglish-wrapper">
    <img src="@/assets/img/asyouthenglish/asyouthenglish.png" />

    <!-- <ul class="btn-inquiry">
      <li>
        <a href="https://pp7lz.channel.io/support-bots/58449" target="_blank"></a>
      </li>
    </ul> -->

    <ul class="btn-list1">
      <li>
        <a href="https://lifeedu.carrotapply.com/home?idxLeSiteMain=13" target="_blank"></a>
      </li>
      <li>
        <a href="https://lifeedu.carrotapply.com/home?idxLeSiteMain=14" target="_blank"></a>
      </li>
    </ul>

    <ul class="btn-list2">
      <li>
        <a href="https://lifeedu.carrotapply.com/learningSupport/noticeDetail?idxNotice=36&idxLeSiteMain=14" target="_blank"></a>
      </li>
      <li>
        <a href="https://pp7lz.channel.io/support-bots/58449" target="_blank"></a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  head: {
    title: {
      inner: "아산시 화상영어",
    },
    meta: [
      { name: "naver-site-verification", content: "2f21f24b290ac8043ee2f84fc9ff0bfd" },
      { name: "google-site-verification", content: "ea8c076255a401f1" },
      {
        name: "keywords",
        content:
          "아산시 화상영어, 아산 화상영어, 아산시 원어민영어, 아산 원어민영어, 아산시 화상학습, 아산시 원어민 화상영어, 아산 원어민 화상영어, 아산시 원어민 학습, 아산 원어민 학습, 아산시 영어 학습, 아산 영어 학습, 아산시 영어 화상, 아산 영어 화상, 아산시 화상 외국어교육, 아산 화상 외국어교육, 아산시 화상영어교실, 아산 화상영어교실, 아산시 원어민 화상학습, 아산 원어민 화상학습, 아산시 평생교육, 아산 평생교육, 아산시 주니어화상영어, 아산 주니어화상영어, 아산시 사회적배려대상 영어, 아산 사회적배려대상 영어, 아산시 영어 주니어, 아산 영어 주니어, 아산시 그룹 영어, 아산 그룹 영어, 아산시 영어 그룹수업, 아산 영어 그룹수업",
      },
      { name: "description", content: "화상영어 무료수업 신청, 영어 티칭경력 5년 이상의 차별화된 외국 원어민 선생님과 무료수업으로 맞춤 외국어 레벨을 찾아보세요!" },
      { name: "viewport", content: "width=device-width" },
      { property: "og:type", content: "website" },
      { property: "og:title", content: "아산시 화상영어" },
      { property: "og:description", content: "화상영어 무료수업 신청, 영어 티칭경력 5년 이상의 차별화된 외국 원어민 선생님과 무료수업으로 맞춤 외국어 레벨을 찾아보세요!" },
      { property: "og:url", content: "https://asyouthenglish.com/" },
      { property: "og:image", content: "https://asyouthenglish.com/img/asyouthenglish.54f0df57.png" },
    ],
  },
};
</script>

<style lang="scss" scoped>
.jinjuenglish-wrapper {
  position: relative;
  max-width: 800px;
  margin: 0 auto;

  img {
    display: block;
    width: 100%;
  }

  .btn-list1 {
    // position: absolute;
    // left: 0;
    // bottom: 40px;
    // width: 100%;
    // height: 100px;
    // display: flex;
    // gap: 96px;
    // padding: 0 74px;

    position: absolute;
    top: 10%;
    width: 100%;
    height: 6%;
    display: flex;
    gap: 1%;
    padding: 0px 6%;

    li {
      flex-grow: 1;

      a {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }

  .btn-list2 {
    // position: absolute;
    // left: 0;
    // bottom: 40px;
    // width: 100%;
    // height: 100px;
    // display: flex;
    // gap: 96px;
    // padding: 0 74px;

    position: absolute;
    top: 38%;
    width: 100%;
    height: 6%;
    display: flex;
    gap: 1%;
    padding: 0px 6%;

    li {
      flex-grow: 1;

      a {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }

  .btn-inquiry {
    position: absolute;
    top: 2%;
    width: 20%;
    left: 84%;
    height: 6%;
    display: flex;
    gap: 1%;
    padding: 0px 6%;

    li {
      flex-grow: 1;

      a {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
